/**
 *  Powerup
 *
 *  Created by Legman on 21/03/2017.
 *
 */

import Common from "../Common";

/**
 * @class
 */
export default class Powerup {
    /**
     * @param {RaceCar} collector
     */
    constructor(collector) {
        /**
         * @type {boolean}
         */
        this.destroyNextFrame = false;

        /**
         * @type {number}
         */
        this.type = 0;

        /**
         * @type {RaceCar}
         * @protected
         */
        this._collector = collector;

        /**
         * @type {boolean}
         * @protected
         */
        this._activated = false;
    }

    destroy() {
        // override
    }

    /**
     * @param {number} dt
     */
    update(dt) {
        // override
    }

    pause() {
        // override
    }

    resume() {
        // override
    }

    /**
     * @returns {boolean}
     */
    activate() {
        if (!this._activated) {
            this._activated = true;
            return true;
        }
        return false;
    }

    /**
     * @returns {RaceCar}
     */
    get collector() {
        return this._collector;
    }

    /**
     * @returns {boolean}
     */
    get activated() {
        return this._activated;
    }

    /**
     * @returns {Array}
     * @static
     */
    static getRandomTypes() {
        let types = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        let arr = [];

        const count = types.length;
        for (let i = 0; i < count; ++ i) {
            const index = Math.floor(Math.random() * types.length);
            const type = types[index];
            types.splice(index, 1);
            arr.push(type);
        }
        return arr;
    }

    /**
     * @param {number} id
     * @returns {PIXI.Texture}
     * @static
     */
    static getTexture(id) {
        const assets = Common.assets;

        let name;
        switch (id) {
            case 0 : {
                name = "ui_icon_powerup_bomb";
                break;
            }
            case 1 : {
                name = "ui_icon_powerup_candies";
                break;
            }
            case 2 : {
                name = "ui_icon_powerup_flame";
                break;
            }
            case 3 : {
                name = "ui_icon_powerup_glue";
                break;
            }
            case 4 : {
                name = "ui_icon_powerup_lightning";
                break;
            }
            case 5 : {
                name = "ui_icon_powerup_missile";
                break;
            }
            case 6 : {
                name = "ui_icon_powerup_nails";
                break;
            }
            case 7 : {
                name = "ui_icon_powerup_smart_missile";
                break;
            }
            case 8 : {
                name = "ui_icon_powerup_steam";
                break;
            }
            case 9 : {
                name = "ui_icon_powerup_bubbles";
                break;
            }
            case 10 : {
                name = "ui_icon_powerup_butterfly";
                break;
            }
        }
        return assets.getTexture(name);
    }
}